import { DataExporter, makeFilename } from '.';

export default function csv(exporter: DataExporter) {
  const data = exporter();

  const csv = [data.title, data.subTitle, ...data.tables.map(table => [table.header.join(','), ...table.body.map(row => row.join(','))])]
    .flat()
    .join('\n');

  const link = document.createElement('a');
  link.download = `${makeFilename(data)}.csv`;
  link.href = window.URL.createObjectURL(new Blob([csv], { type: 'text/plain' }));
  link.click();
}
